/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import { TourOperatorRemark } from "../TourOperator/TourOperator";
import { LuggageInfo } from "./Luggage";

export enum StopoverHint {
  NoStopOverHint = "NoStopOverHint",
  Usa = "Usa",
  PuertoRico = "PuertoRico",
  UsaAndPuertoRico = "UsaAndPuertoRico",
}

export function stopoverHintFromJSON(object: any): StopoverHint {
  switch (object) {
    case 0:
    case "NoStopOverHint":
      return StopoverHint.NoStopOverHint;
    case 1:
    case "Usa":
      return StopoverHint.Usa;
    case 2:
    case "PuertoRico":
      return StopoverHint.PuertoRico;
    case 3:
    case "UsaAndPuertoRico":
      return StopoverHint.UsaAndPuertoRico;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum StopoverHint"
      );
  }
}

export function stopoverHintToJSON(object: StopoverHint): string {
  switch (object) {
    case StopoverHint.NoStopOverHint:
      return "NoStopOverHint";
    case StopoverHint.Usa:
      return "Usa";
    case StopoverHint.PuertoRico:
      return "PuertoRico";
    case StopoverHint.UsaAndPuertoRico:
      return "UsaAndPuertoRico";
    default:
      return "UNKNOWN";
  }
}

export function stopoverHintToNumber(object: StopoverHint): number {
  switch (object) {
    case StopoverHint.NoStopOverHint:
      return 0;
    case StopoverHint.Usa:
      return 1;
    case StopoverHint.PuertoRico:
      return 2;
    case StopoverHint.UsaAndPuertoRico:
      return 3;
    default:
      return 0;
  }
}

export enum OvernightHint {
  NoOverNightHint = "NoOverNightHint",
  FirstNight = "FirstNight",
  LastNight = "LastNight",
  FirstAndLastNight = "FirstAndLastNight",
  Generic = "Generic",
}

export function overnightHintFromJSON(object: any): OvernightHint {
  switch (object) {
    case 0:
    case "NoOverNightHint":
      return OvernightHint.NoOverNightHint;
    case 1:
    case "FirstNight":
      return OvernightHint.FirstNight;
    case 2:
    case "LastNight":
      return OvernightHint.LastNight;
    case 3:
    case "FirstAndLastNight":
      return OvernightHint.FirstAndLastNight;
    case 4:
    case "Generic":
      return OvernightHint.Generic;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum OvernightHint"
      );
  }
}

export function overnightHintToJSON(object: OvernightHint): string {
  switch (object) {
    case OvernightHint.NoOverNightHint:
      return "NoOverNightHint";
    case OvernightHint.FirstNight:
      return "FirstNight";
    case OvernightHint.LastNight:
      return "LastNight";
    case OvernightHint.FirstAndLastNight:
      return "FirstAndLastNight";
    case OvernightHint.Generic:
      return "Generic";
    default:
      return "UNKNOWN";
  }
}

export function overnightHintToNumber(object: OvernightHint): number {
  switch (object) {
    case OvernightHint.NoOverNightHint:
      return 0;
    case OvernightHint.FirstNight:
      return 1;
    case OvernightHint.LastNight:
      return 2;
    case OvernightHint.FirstAndLastNight:
      return 3;
    case OvernightHint.Generic:
      return 4;
    default:
      return 0;
  }
}

export enum FlightHint {
  NoFlightHint = "NoFlightHint",
  HintWithoutCheckinTime = "HintWithoutCheckinTime",
  HintWithCheckinTime = "HintWithCheckinTime",
}

export function flightHintFromJSON(object: any): FlightHint {
  switch (object) {
    case 0:
    case "NoFlightHint":
      return FlightHint.NoFlightHint;
    case 1:
    case "HintWithoutCheckinTime":
      return FlightHint.HintWithoutCheckinTime;
    case 2:
    case "HintWithCheckinTime":
      return FlightHint.HintWithCheckinTime;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum FlightHint"
      );
  }
}

export function flightHintToJSON(object: FlightHint): string {
  switch (object) {
    case FlightHint.NoFlightHint:
      return "NoFlightHint";
    case FlightHint.HintWithoutCheckinTime:
      return "HintWithoutCheckinTime";
    case FlightHint.HintWithCheckinTime:
      return "HintWithCheckinTime";
    default:
      return "UNKNOWN";
  }
}

export function flightHintToNumber(object: FlightHint): number {
  switch (object) {
    case FlightHint.NoFlightHint:
      return 0;
    case FlightHint.HintWithoutCheckinTime:
      return 1;
    case FlightHint.HintWithCheckinTime:
      return 2;
    default:
      return 0;
  }
}

export interface Airline {
  code: string;
  name: string;
  remark?: TourOperatorRemark;
}

export interface Airport {
  code: string;
  name: string;
  cityName: string;
  countryName: string;
  countryCode: string;
}

export interface FlightNode {
  localDateTime: string;
  germanTime: string;
  airport?: Airport;
}

export interface FlightSegment {
  duration: number;
  lengthOfStay: number;
  flightNumber: string;
  cabinClass: string;
  onlineCheckIn: FlightSegment_OnlineCheckIn;
  departure?: FlightNode;
  arrival?: FlightNode;
  airline?: Airline;
}

export enum FlightSegment_OnlineCheckIn {
  OnlineCheckInUnknown = "OnlineCheckInUnknown",
  Possible = "Possible",
  NotPossible = "NotPossible",
  Required = "Required",
}

export function flightSegment_OnlineCheckInFromJSON(
  object: any
): FlightSegment_OnlineCheckIn {
  switch (object) {
    case 0:
    case "OnlineCheckInUnknown":
      return FlightSegment_OnlineCheckIn.OnlineCheckInUnknown;
    case 1:
    case "Possible":
      return FlightSegment_OnlineCheckIn.Possible;
    case 2:
    case "NotPossible":
      return FlightSegment_OnlineCheckIn.NotPossible;
    case 3:
    case "Required":
      return FlightSegment_OnlineCheckIn.Required;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum FlightSegment_OnlineCheckIn"
      );
  }
}

export function flightSegment_OnlineCheckInToJSON(
  object: FlightSegment_OnlineCheckIn
): string {
  switch (object) {
    case FlightSegment_OnlineCheckIn.OnlineCheckInUnknown:
      return "OnlineCheckInUnknown";
    case FlightSegment_OnlineCheckIn.Possible:
      return "Possible";
    case FlightSegment_OnlineCheckIn.NotPossible:
      return "NotPossible";
    case FlightSegment_OnlineCheckIn.Required:
      return "Required";
    default:
      return "UNKNOWN";
  }
}

export function flightSegment_OnlineCheckInToNumber(
  object: FlightSegment_OnlineCheckIn
): number {
  switch (object) {
    case FlightSegment_OnlineCheckIn.OnlineCheckInUnknown:
      return 0;
    case FlightSegment_OnlineCheckIn.Possible:
      return 1;
    case FlightSegment_OnlineCheckIn.NotPossible:
      return 2;
    case FlightSegment_OnlineCheckIn.Required:
      return 3;
    default:
      return 0;
  }
}

export interface FlightTime {
  timezoneOffset: number;
  dateTime: string;
}

export interface FlightDirection {
  hasMultipleAirlines: boolean;
  hasValidFlightTimes: boolean;
  duration: number;
  stops: number;
  departure?: FlightTime;
  arrival?: FlightTime;
  airline?: Airline;
  airport?: Airport;
  luggageInfo?: LuggageInfo;
  segments: FlightSegment[];
}

export interface VisaConditions {
  urlString: string;
  stopsHint: string;
}

function createBaseAirline(): Airline {
  return { code: "", name: "", remark: undefined };
}

export const Airline = {
  encode(
    message: Airline,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.remark !== undefined) {
      TourOperatorRemark.encode(
        message.remark,
        writer.uint32(26).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Airline {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirline();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.code = reader.string();
          break;
        case 2:
          message.name = reader.string();
          break;
        case 3:
          message.remark = TourOperatorRemark.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Airline {
    return {
      code: isSet(object.code) ? String(object.code) : "",
      name: isSet(object.name) ? String(object.name) : "",
      remark: isSet(object.remark)
        ? TourOperatorRemark.fromJSON(object.remark)
        : undefined,
    };
  },

  toJSON(message: Airline): unknown {
    const obj: any = {};
    message.code !== undefined && (obj.code = message.code);
    message.name !== undefined && (obj.name = message.name);
    message.remark !== undefined &&
      (obj.remark = message.remark
        ? TourOperatorRemark.toJSON(message.remark)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<Airline>): Airline {
    const message = createBaseAirline();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.remark =
      object.remark !== undefined && object.remark !== null
        ? TourOperatorRemark.fromPartial(object.remark)
        : undefined;
    return message;
  },
};

function createBaseAirport(): Airport {
  return { code: "", name: "", cityName: "", countryName: "", countryCode: "" };
}

export const Airport = {
  encode(
    message: Airport,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.cityName !== "") {
      writer.uint32(26).string(message.cityName);
    }
    if (message.countryName !== "") {
      writer.uint32(34).string(message.countryName);
    }
    if (message.countryCode !== "") {
      writer.uint32(42).string(message.countryCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Airport {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAirport();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.code = reader.string();
          break;
        case 2:
          message.name = reader.string();
          break;
        case 3:
          message.cityName = reader.string();
          break;
        case 4:
          message.countryName = reader.string();
          break;
        case 5:
          message.countryCode = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Airport {
    return {
      code: isSet(object.code) ? String(object.code) : "",
      name: isSet(object.name) ? String(object.name) : "",
      cityName: isSet(object.cityName) ? String(object.cityName) : "",
      countryName: isSet(object.countryName) ? String(object.countryName) : "",
      countryCode: isSet(object.countryCode) ? String(object.countryCode) : "",
    };
  },

  toJSON(message: Airport): unknown {
    const obj: any = {};
    message.code !== undefined && (obj.code = message.code);
    message.name !== undefined && (obj.name = message.name);
    message.cityName !== undefined && (obj.cityName = message.cityName);
    message.countryName !== undefined &&
      (obj.countryName = message.countryName);
    message.countryCode !== undefined &&
      (obj.countryCode = message.countryCode);
    return obj;
  },

  fromPartial(object: DeepPartial<Airport>): Airport {
    const message = createBaseAirport();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.cityName = object.cityName ?? "";
    message.countryName = object.countryName ?? "";
    message.countryCode = object.countryCode ?? "";
    return message;
  },
};

function createBaseFlightNode(): FlightNode {
  return { localDateTime: "", germanTime: "", airport: undefined };
}

export const FlightNode = {
  encode(
    message: FlightNode,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.localDateTime !== "") {
      writer.uint32(10).string(message.localDateTime);
    }
    if (message.germanTime !== "") {
      writer.uint32(18).string(message.germanTime);
    }
    if (message.airport !== undefined) {
      Airport.encode(message.airport, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FlightNode {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.localDateTime = reader.string();
          break;
        case 2:
          message.germanTime = reader.string();
          break;
        case 3:
          message.airport = Airport.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FlightNode {
    return {
      localDateTime: isSet(object.localDateTime)
        ? String(object.localDateTime)
        : "",
      germanTime: isSet(object.germanTime) ? String(object.germanTime) : "",
      airport: isSet(object.airport)
        ? Airport.fromJSON(object.airport)
        : undefined,
    };
  },

  toJSON(message: FlightNode): unknown {
    const obj: any = {};
    message.localDateTime !== undefined &&
      (obj.localDateTime = message.localDateTime);
    message.germanTime !== undefined && (obj.germanTime = message.germanTime);
    message.airport !== undefined &&
      (obj.airport = message.airport
        ? Airport.toJSON(message.airport)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<FlightNode>): FlightNode {
    const message = createBaseFlightNode();
    message.localDateTime = object.localDateTime ?? "";
    message.germanTime = object.germanTime ?? "";
    message.airport =
      object.airport !== undefined && object.airport !== null
        ? Airport.fromPartial(object.airport)
        : undefined;
    return message;
  },
};

function createBaseFlightSegment(): FlightSegment {
  return {
    duration: 0,
    lengthOfStay: 0,
    flightNumber: "",
    cabinClass: "",
    onlineCheckIn: FlightSegment_OnlineCheckIn.OnlineCheckInUnknown,
    departure: undefined,
    arrival: undefined,
    airline: undefined,
  };
}

export const FlightSegment = {
  encode(
    message: FlightSegment,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.duration !== 0) {
      writer.uint32(32).uint32(message.duration);
    }
    if (message.lengthOfStay !== 0) {
      writer.uint32(56).uint32(message.lengthOfStay);
    }
    if (message.flightNumber !== "") {
      writer.uint32(42).string(message.flightNumber);
    }
    if (message.cabinClass !== "") {
      writer.uint32(50).string(message.cabinClass);
    }
    if (
      message.onlineCheckIn !== FlightSegment_OnlineCheckIn.OnlineCheckInUnknown
    ) {
      writer
        .uint32(64)
        .int32(flightSegment_OnlineCheckInToNumber(message.onlineCheckIn));
    }
    if (message.departure !== undefined) {
      FlightNode.encode(message.departure, writer.uint32(10).fork()).ldelim();
    }
    if (message.arrival !== undefined) {
      FlightNode.encode(message.arrival, writer.uint32(18).fork()).ldelim();
    }
    if (message.airline !== undefined) {
      Airline.encode(message.airline, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FlightSegment {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightSegment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          message.duration = reader.uint32();
          break;
        case 7:
          message.lengthOfStay = reader.uint32();
          break;
        case 5:
          message.flightNumber = reader.string();
          break;
        case 6:
          message.cabinClass = reader.string();
          break;
        case 8:
          message.onlineCheckIn = flightSegment_OnlineCheckInFromJSON(
            reader.int32()
          );
          break;
        case 1:
          message.departure = FlightNode.decode(reader, reader.uint32());
          break;
        case 2:
          message.arrival = FlightNode.decode(reader, reader.uint32());
          break;
        case 3:
          message.airline = Airline.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FlightSegment {
    return {
      duration: isSet(object.duration) ? Number(object.duration) : 0,
      lengthOfStay: isSet(object.lengthOfStay)
        ? Number(object.lengthOfStay)
        : 0,
      flightNumber: isSet(object.flightNumber)
        ? String(object.flightNumber)
        : "",
      cabinClass: isSet(object.cabinClass) ? String(object.cabinClass) : "",
      onlineCheckIn: isSet(object.onlineCheckIn)
        ? flightSegment_OnlineCheckInFromJSON(object.onlineCheckIn)
        : FlightSegment_OnlineCheckIn.OnlineCheckInUnknown,
      departure: isSet(object.departure)
        ? FlightNode.fromJSON(object.departure)
        : undefined,
      arrival: isSet(object.arrival)
        ? FlightNode.fromJSON(object.arrival)
        : undefined,
      airline: isSet(object.airline)
        ? Airline.fromJSON(object.airline)
        : undefined,
    };
  },

  toJSON(message: FlightSegment): unknown {
    const obj: any = {};
    message.duration !== undefined &&
      (obj.duration = Math.round(message.duration));
    message.lengthOfStay !== undefined &&
      (obj.lengthOfStay = Math.round(message.lengthOfStay));
    message.flightNumber !== undefined &&
      (obj.flightNumber = message.flightNumber);
    message.cabinClass !== undefined && (obj.cabinClass = message.cabinClass);
    message.onlineCheckIn !== undefined &&
      (obj.onlineCheckIn = flightSegment_OnlineCheckInToJSON(
        message.onlineCheckIn
      ));
    message.departure !== undefined &&
      (obj.departure = message.departure
        ? FlightNode.toJSON(message.departure)
        : undefined);
    message.arrival !== undefined &&
      (obj.arrival = message.arrival
        ? FlightNode.toJSON(message.arrival)
        : undefined);
    message.airline !== undefined &&
      (obj.airline = message.airline
        ? Airline.toJSON(message.airline)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<FlightSegment>): FlightSegment {
    const message = createBaseFlightSegment();
    message.duration = object.duration ?? 0;
    message.lengthOfStay = object.lengthOfStay ?? 0;
    message.flightNumber = object.flightNumber ?? "";
    message.cabinClass = object.cabinClass ?? "";
    message.onlineCheckIn =
      object.onlineCheckIn ?? FlightSegment_OnlineCheckIn.OnlineCheckInUnknown;
    message.departure =
      object.departure !== undefined && object.departure !== null
        ? FlightNode.fromPartial(object.departure)
        : undefined;
    message.arrival =
      object.arrival !== undefined && object.arrival !== null
        ? FlightNode.fromPartial(object.arrival)
        : undefined;
    message.airline =
      object.airline !== undefined && object.airline !== null
        ? Airline.fromPartial(object.airline)
        : undefined;
    return message;
  },
};

function createBaseFlightTime(): FlightTime {
  return { timezoneOffset: 0, dateTime: "" };
}

export const FlightTime = {
  encode(
    message: FlightTime,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.timezoneOffset !== 0) {
      writer.uint32(8).sint32(message.timezoneOffset);
    }
    if (message.dateTime !== "") {
      writer.uint32(18).string(message.dateTime);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FlightTime {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightTime();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.timezoneOffset = reader.sint32();
          break;
        case 2:
          message.dateTime = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FlightTime {
    return {
      timezoneOffset: isSet(object.timezoneOffset)
        ? Number(object.timezoneOffset)
        : 0,
      dateTime: isSet(object.dateTime) ? String(object.dateTime) : "",
    };
  },

  toJSON(message: FlightTime): unknown {
    const obj: any = {};
    message.timezoneOffset !== undefined &&
      (obj.timezoneOffset = Math.round(message.timezoneOffset));
    message.dateTime !== undefined && (obj.dateTime = message.dateTime);
    return obj;
  },

  fromPartial(object: DeepPartial<FlightTime>): FlightTime {
    const message = createBaseFlightTime();
    message.timezoneOffset = object.timezoneOffset ?? 0;
    message.dateTime = object.dateTime ?? "";
    return message;
  },
};

function createBaseFlightDirection(): FlightDirection {
  return {
    hasMultipleAirlines: false,
    hasValidFlightTimes: false,
    duration: 0,
    stops: 0,
    departure: undefined,
    arrival: undefined,
    airline: undefined,
    airport: undefined,
    luggageInfo: undefined,
    segments: [],
  };
}

export const FlightDirection = {
  encode(
    message: FlightDirection,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.hasMultipleAirlines === true) {
      writer.uint32(64).bool(message.hasMultipleAirlines);
    }
    if (message.hasValidFlightTimes === true) {
      writer.uint32(72).bool(message.hasValidFlightTimes);
    }
    if (message.duration !== 0) {
      writer.uint32(48).uint32(message.duration);
    }
    if (message.stops !== 0) {
      writer.uint32(40).sint32(message.stops);
    }
    if (message.departure !== undefined) {
      FlightTime.encode(message.departure, writer.uint32(10).fork()).ldelim();
    }
    if (message.arrival !== undefined) {
      FlightTime.encode(message.arrival, writer.uint32(18).fork()).ldelim();
    }
    if (message.airline !== undefined) {
      Airline.encode(message.airline, writer.uint32(26).fork()).ldelim();
    }
    if (message.airport !== undefined) {
      Airport.encode(message.airport, writer.uint32(34).fork()).ldelim();
    }
    if (message.luggageInfo !== undefined) {
      LuggageInfo.encode(
        message.luggageInfo,
        writer.uint32(90).fork()
      ).ldelim();
    }
    for (const v of message.segments) {
      FlightSegment.encode(v!, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FlightDirection {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFlightDirection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 8:
          message.hasMultipleAirlines = reader.bool();
          break;
        case 9:
          message.hasValidFlightTimes = reader.bool();
          break;
        case 6:
          message.duration = reader.uint32();
          break;
        case 5:
          message.stops = reader.sint32();
          break;
        case 1:
          message.departure = FlightTime.decode(reader, reader.uint32());
          break;
        case 2:
          message.arrival = FlightTime.decode(reader, reader.uint32());
          break;
        case 3:
          message.airline = Airline.decode(reader, reader.uint32());
          break;
        case 4:
          message.airport = Airport.decode(reader, reader.uint32());
          break;
        case 11:
          message.luggageInfo = LuggageInfo.decode(reader, reader.uint32());
          break;
        case 7:
          message.segments.push(FlightSegment.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): FlightDirection {
    return {
      hasMultipleAirlines: isSet(object.hasMultipleAirlines)
        ? Boolean(object.hasMultipleAirlines)
        : false,
      hasValidFlightTimes: isSet(object.hasValidFlightTimes)
        ? Boolean(object.hasValidFlightTimes)
        : false,
      duration: isSet(object.duration) ? Number(object.duration) : 0,
      stops: isSet(object.stops) ? Number(object.stops) : 0,
      departure: isSet(object.departure)
        ? FlightTime.fromJSON(object.departure)
        : undefined,
      arrival: isSet(object.arrival)
        ? FlightTime.fromJSON(object.arrival)
        : undefined,
      airline: isSet(object.airline)
        ? Airline.fromJSON(object.airline)
        : undefined,
      airport: isSet(object.airport)
        ? Airport.fromJSON(object.airport)
        : undefined,
      luggageInfo: isSet(object.luggageInfo)
        ? LuggageInfo.fromJSON(object.luggageInfo)
        : undefined,
      segments: Array.isArray(object?.segments)
        ? object.segments.map((e: any) => FlightSegment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FlightDirection): unknown {
    const obj: any = {};
    message.hasMultipleAirlines !== undefined &&
      (obj.hasMultipleAirlines = message.hasMultipleAirlines);
    message.hasValidFlightTimes !== undefined &&
      (obj.hasValidFlightTimes = message.hasValidFlightTimes);
    message.duration !== undefined &&
      (obj.duration = Math.round(message.duration));
    message.stops !== undefined && (obj.stops = Math.round(message.stops));
    message.departure !== undefined &&
      (obj.departure = message.departure
        ? FlightTime.toJSON(message.departure)
        : undefined);
    message.arrival !== undefined &&
      (obj.arrival = message.arrival
        ? FlightTime.toJSON(message.arrival)
        : undefined);
    message.airline !== undefined &&
      (obj.airline = message.airline
        ? Airline.toJSON(message.airline)
        : undefined);
    message.airport !== undefined &&
      (obj.airport = message.airport
        ? Airport.toJSON(message.airport)
        : undefined);
    message.luggageInfo !== undefined &&
      (obj.luggageInfo = message.luggageInfo
        ? LuggageInfo.toJSON(message.luggageInfo)
        : undefined);
    if (message.segments) {
      obj.segments = message.segments.map((e) =>
        e ? FlightSegment.toJSON(e) : undefined
      );
    } else {
      obj.segments = [];
    }
    return obj;
  },

  fromPartial(object: DeepPartial<FlightDirection>): FlightDirection {
    const message = createBaseFlightDirection();
    message.hasMultipleAirlines = object.hasMultipleAirlines ?? false;
    message.hasValidFlightTimes = object.hasValidFlightTimes ?? false;
    message.duration = object.duration ?? 0;
    message.stops = object.stops ?? 0;
    message.departure =
      object.departure !== undefined && object.departure !== null
        ? FlightTime.fromPartial(object.departure)
        : undefined;
    message.arrival =
      object.arrival !== undefined && object.arrival !== null
        ? FlightTime.fromPartial(object.arrival)
        : undefined;
    message.airline =
      object.airline !== undefined && object.airline !== null
        ? Airline.fromPartial(object.airline)
        : undefined;
    message.airport =
      object.airport !== undefined && object.airport !== null
        ? Airport.fromPartial(object.airport)
        : undefined;
    message.luggageInfo =
      object.luggageInfo !== undefined && object.luggageInfo !== null
        ? LuggageInfo.fromPartial(object.luggageInfo)
        : undefined;
    message.segments =
      object.segments?.map((e) => FlightSegment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVisaConditions(): VisaConditions {
  return { urlString: "", stopsHint: "" };
}

export const VisaConditions = {
  encode(
    message: VisaConditions,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.urlString !== "") {
      writer.uint32(10).string(message.urlString);
    }
    if (message.stopsHint !== "") {
      writer.uint32(18).string(message.stopsHint);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VisaConditions {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVisaConditions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.urlString = reader.string();
          break;
        case 2:
          message.stopsHint = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): VisaConditions {
    return {
      urlString: isSet(object.urlString) ? String(object.urlString) : "",
      stopsHint: isSet(object.stopsHint) ? String(object.stopsHint) : "",
    };
  },

  toJSON(message: VisaConditions): unknown {
    const obj: any = {};
    message.urlString !== undefined && (obj.urlString = message.urlString);
    message.stopsHint !== undefined && (obj.stopsHint = message.stopsHint);
    return obj;
  },

  fromPartial(object: DeepPartial<VisaConditions>): VisaConditions {
    const message = createBaseVisaConditions();
    message.urlString = object.urlString ?? "";
    message.stopsHint = object.stopsHint ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
